
export const LOGIN_USER = "LOGIN_USER"

export const REGISTER_USER = "REGISTER_USER"

export const AXIOS_DATA = "AXIOS_DATA"

export const AXIOS_SUCCESS = "AXIOS_SUCCESS"